import React, { useEffect, useState ,useRef} from "react";
import axiosInstance from "../api/axiosInstance";

export default function PharmacistApproval() {

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [mode, setMode] = useState("delivery");

const [showRejectModal, setShowRejectModal] = useState(false);
const [rejectOrderId, setRejectOrderId] = useState(null);
const [rejectReason, setRejectReason] = useState("");

const [approveType, setApproveType] = useState("direct"); // direct | manual


const [successMsg, setSuccessMsg] = useState("");

const [files, setFiles] = useState([]);   // multiple files
const [amount, setAmount] = useState("");
const [note, setNote] = useState("");

const [showDeliveryModal, setShowDeliveryModal] = useState(false);
const fileInputRef = useRef();
  /* ---------------- LOAD ORDERS ---------------- */



  const loadOrders = async () => {
    try {

      const res = await axiosInstance.get("/orders/pending-rx/");
      setOrders(res.data);

    } catch (err) {

      console.error(err);
      alert("Failed to load orders ❌");

    }
  };


  useEffect(() => {
    loadOrders();
  }, []);

const handleFileUpload = (e) => {
  const selected = Array.from(e.target.files);

  setFiles((prev) => [...prev, ...selected]);
};


const removeFile = (index) => {
  setFiles(files.filter((_, i) => i !== index));
};




  /* ---------------- MODAL HANDLERS ---------------- */

const openDecisionModal = (id) => {

  setSelectedOrder(id);

  setApproveType("direct");
  setMode("delivery");

  setAmount("");
  setNote("");
  setFiles([]);

  setShowModal(true);
};


useEffect(() => {

  return () => {
    files.forEach(file => {
      URL.revokeObjectURL(file);
    });
  };

}, [files]);


const finalizeOrder = async () => {

  try {

    if (approveType === "manual") {
      if (!amount || files.length === 0) {
        alert("Upload bill & enter amount ❗");
        return;
      }
    }

    const form = new FormData();

    form.append("order_id", selectedOrder);
    form.append("mode", mode);

    if (approveType === "manual") {

      form.append("amount", amount);
      form.append("note", note);

      files.forEach((file) => {
        form.append("files", file);
      });

    }

    await axiosInstance.post(
      "/pharmacist/finalize-order/",
      form,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );


    // ✅ show success
    setSuccessMsg("Order approved successfully ✅");

    setTimeout(() => {
      setSuccessMsg("");
    }, 2000);


    // close modal
    setShowModal(false);
    setShowDeliveryModal(false);


    // reset
    setSelectedOrder(null);
    setApproveType("direct");
    setFiles([]);
    setAmount("");
    setNote("");


    // ✅ UPDATE STATUS INSTEAD OF REMOVING
    setOrders(prev =>
      prev.map(o =>
        o.id === selectedOrder
          ? {
              ...o,
              status:
                mode === "pickup"
                  ? "approved_store_pickup"
                  : "ready_for_payment"
            }
          : o
      )
    );


  } catch (err) {

    console.error(err);
    alert("Approval failed ❌");

  }

};
	

const submitReject = async () => {

  if (!rejectReason.trim()) {
    alert("Please enter reason");
    return;
  }

  try {

    await axiosInstance.post("/pharmacist/approve-order/", {
      order_id: rejectOrderId,
      action: "reject",
      reason: rejectReason
    });

    alert("Order rejected ❌");

    setShowRejectModal(false);
    setRejectReason("");
    setRejectOrderId(null);

    loadOrders();

  } catch (err) {

    alert(
      err.response?.data?.error ||
      "Failed to reject"
    );

  }
};


  /* ---------------- REJECT ---------------- */

  const rejectOrder = async (id) => {

    const ok = window.confirm("Reject this order?");

    if (!ok) return;

    try {

      setLoading(true);

      await axiosInstance.post("/pharmacist/approve-order/", {
        order_id: id,
        action: "reject"
      });

      alert("Order rejected ❌");

      loadOrders();

    } catch {

      alert("Failed");

    } finally {

      setLoading(false);

    }
  };


  /* ---------------- UI ---------------- */

  return (
    <div style={container}>

      <h1>💊 Pharmacist Approval Panel</h1>

{successMsg && (
  <div style={{
    background: "#16a34a",
    color: "white",
    padding: "8px 14px",
    borderRadius: 6,
    marginBottom: 12,
    textAlign: "center"
  }}>
    {successMsg}
  </div>
)}

      {orders.length === 0 && (
        <p>No pending RX orders 🎉</p>
      )}


      {/* ---------------- MODAL ---------------- */}
      {showModal && (
        <div style={modalBg}>

          <div style={modalBox}>

        <h3>Approve Order</h3>

{/* APPROVE TYPE */}
<label>
  <input
    type="radio"
    checked={approveType === "direct"}
    onChange={() => setApproveType("direct")}
  />
  Direct Approve
</label>

<br />

<label>
  <input
    type="radio"
    checked={approveType === "manual"}
    onChange={() => setApproveType("manual")}
  />
  Manual Approve
</label>

<hr />

{/* ✅ DIRECT → SHOW DELIVERY MODE */}
{approveType === "direct" && (
  <>
    <h4>Delivery Mode</h4>

    <label>
      <input
        type="radio"
        checked={mode === "delivery"}
        onChange={() => setMode("delivery")}
      />
      Home Delivery
    </label>

    <br />

    <label>
      <input
        type="radio"
        checked={mode === "pickup"}
        onChange={() => setMode("pickup")}
      />
      Store Pickup
    </label>
  </>
)}


{/* ✅ DIRECT → SHOW DELIVERY MODE */}


{/* ✅ MANUAL → SHOW BILL UPLOAD */}
{/* ===== MANUAL PRICING ===== */}
{approveType === "manual" && (

  <>
    <h4>📤 Upload Bills / Receipts</h4>

<input
  type="file"
  multiple
  accept="image/*,.pdf"
  onChange={handleFileUpload}
  ref={fileInputRef}
  style={{ display: "none" }}
/>
<button
  onClick={() => fileInputRef.current.click()}
  style={addBtn}
>
  ➕ Add More Files
</button>


  {/* FILE PREVIEW LIST */}

{files.map((file, i) => {

  const fileURL = URL.createObjectURL(file);

  return (

    <div key={i} style={fileRow}>

      {/* File Name */}
      <span style={{ flex: 1 }}>
        {file.name}
      </span>

      {/* VIEW LINK */}
      <a
        href={fileURL}
        target="_blank"
        rel="noreferrer"
        style={viewLink}
      >
        🔗 View
      </a>

      {/* REMOVE */}
      <button
        onClick={() => removeFile(i)}
        style={removeBtn}
      >
        ❌
      </button>

    </div>
  );
})}


    <br />

    <input
      type="number"
      placeholder="Total Amount ₹"
      value={amount}
      onChange={(e) => setAmount(e.target.value)}
      style={inputBox}
    />

    <br /><br />

    <textarea
      placeholder="Note (Optional)"
      value={note}
      onChange={(e) => setNote(e.target.value)}
      rows={3}
      style={inputBox}
    />
  </>
)}

	

            <br /><br />

           <button
  onClick={() => {

    if (approveType === "manual") {

      if (!amount || files.length === 0) {
        alert("Upload bill & enter amount ❗");
        return;
      }

      setShowModal(false);
      setShowDeliveryModal(true); // OPEN NEXT STEP
    }

    else {
      finalizeOrder(); // direct approve
    }

  }}
  style={approveBtn}
>
  Confirm
</button>


            <button
              onClick={() => setShowModal(false)}
              style={cancelBtn}
            >
              Cancel
            </button>

          </div>

        </div>
      )}











{/* ❌ REJECT MODAL */}
{showRejectModal && (

  <div style={modalBg}>

    <div style={modalBox}>

      <h3>Reject Order</h3>

      <p>Reason for rejection:</p>

      <textarea
        value={rejectReason}
        onChange={(e) => setRejectReason(e.target.value)}
        rows="4"
        style={{
          width: "100%",
          padding: 8,
          borderRadius: 5,
          border: "1px solid #ccc"
        }}
      />

      <br /><br />

      <button
        onClick={submitReject}
        style={rejectBtn}
      >
        ❌ Confirm Reject
      </button>

      <button
        onClick={() => {
          setShowRejectModal(false);
          setRejectReason("");
        }}
        style={cancelBtn}
      >
        Cancel
      </button>

    </div>

  </div>
)}



      {orders.map(order => (

        <div key={order.id} style={card}>


          {/* Header */}
          <div style={headerRow}>

            <h3>Order #{order.id}</h3>

            <span
  style={{
    ...badge,
    background:
      order.status?.includes("approved")
        ? "#16a34a"
        : "#facc15"
  }}
>
  {order.status || "Pending"}
</span>


          </div>


          {/* User Info */}
          <p><b>👤 User:</b> {order.user}</p>
          <p><b>📞 Phone:</b> {order.phone}</p>
          <p><b>💰 Total:</b> ₹{order.total}</p>


          {/* Items */}
          <h4>💊 Medicines</h4>

          {order.items.map((item, i) => (

            <div key={i} style={itemRow}>

    <span>{item.product_name || item.name}</span>
<span>× {item.quantity || item.qty}</span>

	
              <span>

                {/* Call */}
                {item.prescription_status === "pending_call" && (
                  <span style={callBadge}>
                    📞 Call
                  </span>
                )}

                {/* Pickup */}
                {item.prescription_status === "store_pickup" && (
                  <span style={pickupBadge}>
                    🏬 Pickup
                  </span>
                )}

                {/* RX */}
                {item.is_rx &&
                  !["pending_call", "store_pickup"].includes(item.prescription_status) && (
                    <span style={rxBadge}>
                      RX
                    </span>
                  )
                }

                {/* OTC */}
                {!item.is_rx && (
                  <span style={otcBadge}>
                    OTC
                  </span>
                )}

              </span>

            </div>

          ))}


{/* ===== DELIVERY MODAL ===== */}
{showDeliveryModal && (

  <div style={modalBg}>

    <div style={modalBox}>

      <h3>Select Delivery Mode</h3>

      <label>
        <input
          type="radio"
          checked={mode === "delivery"}
          onChange={() => setMode("delivery")}
        />
        Home Delivery
      </label>

      <br />

      <label>
        <input
          type="radio"
          checked={mode === "pickup"}
          onChange={() => setMode("pickup")}
        />
        Store Pickup
      </label>

      <br /><br />

      <button
        onClick={finalizeOrder}
        style={approveBtn}
      >
        Final Approve ✅
      </button>

      <button
        onClick={() => setShowDeliveryModal(false)}
        style={cancelBtn}
      >
        Cancel
      </button>

    </div>

  </div>
)}






<p style={{
  background: "#fff3cd",
  padding: "8px",
  borderRadius: "6px",
  fontSize: "13px",
  color: "#856404",
  marginBottom: "8px"
}}>
  📌 Tip: Download prescriptions to avoid loading issues and ensure uninterrupted review.
</p>




{/* ---------------- PRESCRIPTIONS ---------------- */}

<h4 style={{ marginTop: 12 }}>📄 Prescription Files</h4>

{order.prescriptions?.length === 0 && (
  <p style={{ color: "#888", fontSize: 13 }}>
    No prescription uploaded
  </p>
)}

 {order.prescriptions?.map(file => {

	const BASE_URL = "https://medical-backend-cgj8.onrender.com";

 	 const fullURL = file.url?.startsWith("http")
    		? file.url
    		: BASE_URL + file.url;


        const isImage =
          file.url?.endsWith(".jpg") ||
          file.url?.endsWith(".jpeg") ||
          file.url?.endsWith(".png") ||
          file.url?.endsWith(".webp");

         const isPDF = fullURL?.endsWith(".pdf");

        return (
          <div
            key={file.id}
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              borderRadius: 6,
              marginBottom: 10
            }}
          >

            <div style={{ fontSize: 13, marginBottom: 6 }}>
              📎 {file.name}
            </div>

            {/* IMAGE */}
            {isImage && (
              <>
                <img
  src={fullURL}
  alt="Prescription"
  style={{
    width: "100%",
    maxHeight: "220px",
    borderRadius: 6,
    cursor: "pointer"
  }}
  onClick={() => window.open(fullURL, "_blank")}
/>

<a
  href="#"
  onClick={(e) => {
    e.preventDefault();

    const link = document.createElement("a");
    link.href = fullURL;
    link.download = file.name || "prescription";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
  style={linkStyle}
>
  ⬇ Download Image
</a>
              </>
            )}

            {/* PDF */}
            {isPDF && (
              <>
                <div style={{
                  padding: "20px",
                  textAlign: "center",
                  background: "#f3f4f6",
                  borderRadius: 6
                }}>
                  📄 PDF File
                </div>

                <a href={file.url} target="_blank" rel="noreferrer" style={linkStyle}>
                  👁 View PDF
                </a>

                <a href={file.url} download style={linkStyle}>
                  ⬇ Download PDF
                </a>
              </>
            )}

          </div>
        );
      })}


          {/* Actions */}
          <div style={btnRow}>

<button
  disabled={
    loading ||
    showModal ||

    [
      "approved_delivery",
      "approved_store_pickup",
      "pending_courier_quote",
      "ready_for_payment"
    ].includes(order.status)
  }

  onClick={() => openDecisionModal(order.id)}

  style={{
    ...approveBtn,

    opacity:
      [
        "approved_delivery",
        "approved_store_pickup",
        "pending_courier_quote",
        "ready_for_payment"
      ].includes(order.status)
        ? 0.5
        : 1,

    cursor:
      [
        "approved_delivery",
        "approved_store_pickup",
        "pending_courier_quote",
        "ready_for_payment"
      ].includes(order.status)
        ? "not-allowed"
        : "pointer"
  }}
>
  ✅ Approve
</button>




         <button
  disabled={
    loading ||
    [
      "approved_delivery",
      "approved_store_pickup",
      "pending_courier_quote",
      "ready_for_payment"
    ].includes(order.status)
  }

  onClick={() => {
    setRejectOrderId(order.id);
    setShowRejectModal(true);
  }}

  style={{
    ...rejectBtn,
    opacity: [
      "approved_delivery",
      "approved_store_pickup",
      "pending_courier_quote",
      "ready_for_payment"
    ].includes(order.status)
      ? 0.5
      : 1,
    cursor: [
      "approved_delivery",
      "approved_store_pickup",
      "pending_courier_quote",
      "ready_for_payment"
    ].includes(order.status)
      ? "not-allowed"
      : "pointer"
  }}
>
  ❌ Reject
</button>

              

          </div>

        </div>

      ))}

    </div>
  );
}


/* ---------------- STYLES ---------------- */

const container = {
  maxWidth: 900,
  margin: "auto",
  padding: 20
};

const card = {
  border: "1px solid #e5e7eb",
  padding: 18,
  marginBottom: 18,
  borderRadius: 10,
  background: "#fff",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
};

const headerRow = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 10
};

const badge = {
  background: "#facc15",
  padding: "4px 10px",
  borderRadius: 20,
  fontSize: 12
};

const itemRow = {
  display: "flex",
  justifyContent: "space-between",
  padding: "6px 0",
  borderBottom: "1px dashed #ddd"
};

const rxBadge = {
  background: "#2563eb",
  color: "#fff",
  padding: "2px 6px",
  borderRadius: 5,
  fontSize: 11
};

const callBadge = {
  background: "#f97316",
  color: "#fff",
  padding: "2px 6px",
  borderRadius: 5,
  fontSize: 11
};

const pickupBadge = {
  background: "#059669",
  color: "#fff",
  padding: "2px 6px",
  borderRadius: 5,
  fontSize: 11
};

const otcBadge = {
  background: "#6b7280",
  color: "#fff",
  padding: "2px 6px",
  borderRadius: 5,
  fontSize: 11
};

const btnRow = {
  marginTop: 15,
  display: "flex",
  gap: 12
};

const approveBtn = {
  background: "#16a34a",
  color: "#fff",
  padding: "9px 16px",
  border: "none",
  borderRadius: 6,
  cursor: "pointer"
};

const rejectBtn = {
  background: "#dc2626",
  color: "#fff",
  padding: "9px 16px",
  border: "none",
  borderRadius: 6,
  cursor: "pointer"
};

const cancelBtn = {
  background: "#6b7280",
  color: "#fff",
  padding: "9px 16px",
  border: "none",
  borderRadius: 6,
  marginLeft: 10
};

const modalBg = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999
};

const modalBox = {
  background: "#fff",
  padding: 25,
  borderRadius: 8,
  minWidth: 300
};
const previewRow = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  marginTop: 8,
  padding: 6,
  border: "1px solid #ddd",
  borderRadius: 6
};

const previewImg = {
  width: 60,
  height: 60,
  objectFit: "cover",
  borderRadius: 4
};

const removeBtn = {
  background: "#dc2626",
  color: "#fff",
  border: "none",
  borderRadius: 4,
  padding: "3px 6px",
  cursor: "pointer"
};

const inputBox = {
  width: "100%",
  padding: 8,
  borderRadius: 5,
  border: "1px solid #ccc"
};
const fileRow = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "6px 10px",
  border: "1px solid #ddd",
  borderRadius: 6,
  marginTop: 6,
  background: "#f9fafb"
};

const viewLink = {
  color: "#2563eb",
  fontSize: 13,
  textDecoration: "none",
  fontWeight: 500
};

const addBtn = {
  marginTop: 10,
  background: "#0ea5e9",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  padding: "6px 12px",
  cursor: "pointer",
  fontSize: 13
};
const linkStyle = {
  display: "block",
  marginTop: 6,
  color: "#2563eb",
  fontSize: 13,
  textDecoration: "none",
  fontWeight: 500
};